module.exports = __webpack_public_path__ + "img/MX.b4d928c1.svg";